<template>
  <b-modal
    ref="modalSuccessPackingNonKomship"
    body-class="p-1"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="modal-success d-flex flex-column justify-content-center">
      <b-row class="justify-content-center mb-1 pt-1">
        <b-img
          src="https://storage.googleapis.com/komerce/core/icon-popup-success.png"
          width="100"
          height="100"
        />
      </b-row>
      <b-row class="text-center px-4 justify-content-center mt-[16px] mb-[8px]">
        <p class="text-xl font-bold text-black mb-[8px]">
          Pengajuan Packing Berhasil
        </p>
        <p class="text-black">
          Yuk segera lakukan packing order, agar segera bisa dipickup oleh pihak ekspedisi.
        </p>
      </b-row>
      <b-button
        variant="primary"
        class="w-full"
        @click="close"
      >
        Selesai
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalSuccessPacking',
  methods: {
    show() {
      this.$refs.modalSuccessPackingNonKomship.show()
    },
    close() {
      this.$emit('on-confirm')
      this.$refs.modalSuccessPackingNonKomship.hide()
    },
  },
}
</script>

<style scoped>
.modal-success {
    width: 100%;
    height: 100%;
    background-color: #fff;
}
</style>
